import {Observable} from "rxjs";
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: "root"
})
export abstract class GeolocationService {

    /**
     * Get the user's current position
     */
    public abstract getCurrentPosition(): Observable<GeolocationPosition> ;
}